export default "__VITE_ASSET__CSgZIxVM__"